import { render } from "./uploadBottomUnderwearExcelModal.vue?vue&type=template&id=7c1a5ec2&ts=true"
import script from "./uploadBottomUnderwearExcelModal.vue?vue&type=script&lang=ts"
export * from "./uploadBottomUnderwearExcelModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__